<template>
  <div id="exhpredictionList">
    <div id="tableView" v-loading="this.loading" element-loading-text="加载中">
			<el-row>
        <el-form label-width="75px" :inline="true" class="el-form demo-form-inline">
          <el-row>
           
            <el-col :span="8" class="searchInline">
              <label class="el-form-item__label searchLabel">展位类型</label>
              <el-select size="small" v-model="searchForm.zwlx" placeholder="全部" class="searchSelect" clearable>
                <el-option v-for="item in zwlxOption" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
              </el-select>
            </el-col>
           
            <el-col :span="8" class="searchInline">
              <label class="el-form-item__label searchLabel">展品类型</label>
              <el-select size="small" v-model="searchForm.czlx" placeholder="全部" class="searchSelect" clearable>
                <el-option v-for="item in czlxOption" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
              </el-select>
            </el-col>
            <el-col :span="8" class="searchInline">
              <label class="el-form-item__label searchLabel">类型</label>
              <el-select size="small" v-model="searchForm.reserve2" placeholder="全部" class="searchSelect" >
                <el-option key="01" label="报名档位" value="01"></el-option>
                <el-option key="02" label="审核档位" value="02"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <div>
            <el-form>
              <el-col :span="12" class="btnEditDelete">
                <el-form-item align="left">
                  <el-button type="success" icon="el-icon-plus" size="small" @click="addClick">新增</el-button>
                  <el-button type="danger" icon="el-icon-delete" size="small" @click="deleteClick">删除</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="btnSearchPlus">
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" size="small" @click="searchClick">查询</el-button>
                  <el-button type="clear" icon="el-icon-refresh" size="small" @click="clearClick">重置</el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </el-form>
      </el-row>
			<div class="table_container">
        <el-table class="tableStyle" border id="table" :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" @selection-change="selectionChange"
          :height="tableheight" tooltip-effect="dark" :row-style="rowStyle">
          <el-table-column type="selection" width="35"></el-table-column>
          <el-table-column type="index" label="序号" show-overflow-tooltip width="65" align="center"></el-table-column>
          <el-table-column prop="zwlxmc" label="展位类型" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="czlx" label="展品类型" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              <span>{{scope.row.czlx | setCZLX(that)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="reserve1" label="档位" show-overflow-tooltip align="center"></el-table-column>
          <!-- <el-table-column prop="min" label="最小面积" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="max" label="最大面积" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="minNum" label="最小个数" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="maxNum" label="最大个数" show-overflow-tooltip align="center"></el-table-column> -->
          <el-table-column label="操作" width="75" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="editClick(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--翻页组件-->
        <el-row type="flex" justify="end">
          <paginator v-if="tableData.length>0"></paginator>
        </el-row>
			</div>


      <!-- 审批 -->
      <el-dialog :title="title" :visible.sync="open" :close-on-click-modal="false">
        <el-form :model="form" label-width="130px" :rules="rules" ref="form">
          <el-row>
            <el-col :span="24">
              <el-form-item prop="reserve2" label="类型">
                <el-select size="small" v-model="form.reserve2" placeholder="全部" class="searchSelect" clearable>
                  <el-option key="01" label="报名档位" value="01"></el-option>
                  <el-option key="02" label="审核档位" value="02"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="zwlx" label="展位类型">
                <el-select size="small" v-model="form.zwlx" placeholder="全部" class="searchSelect" clearable @change="checkZwlx">
                  <el-option v-for="item in zwlxOption" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="czlx" label="展品类型">
                <el-select size="small" v-model="form.czlx" placeholder="全部" class="searchSelect" clearable>
                  <el-option v-for="item in czlxOption" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="form.zwlx && form.zwlx != 1">
            <el-col :span="24" >
              <el-form-item prop="min" label="最小面积">
                <el-input size="small" v-model="form.min" placeholder="最小面积" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="form.zwlx && form.zwlx != 1">
            <el-col :span="24">
              <el-form-item prop="max" label="最大面积">
                <el-input size="small" v-model="form.max" placeholder="最大面积" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="form.zwlx && form.zwlx == 1">
            <el-col :span="24">
              <el-form-item prop="minNum" label="最小个数">
                <el-input size="small" v-model="form.minNum" placeholder="最小个数" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="form.zwlx && form.zwlx == 1">
            <el-col :span="24">
              <el-form-item prop="maxNum" label="最大个数">
                <el-input size="small" v-model="form.maxNum" placeholder="最大个数" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row class="buttonSubmit">
          <el-button type="clear" icon="el-icon-close" size="small" @click="closeDialog">取消</el-button>
          <el-button type="success" icon="el-icon-check" size="small" @click="save">保存</el-button>
        </el-row>
      </el-dialog>
		</div>
  </div>
</template>
<script>
//引入翻页 paginator
import paginator from '@/components/paginator'
export default {
  components: {
    paginator
  },
  data() {
    return {
      //当前登陆用户
      currentUser: this.CONSTANT.currentUser,
      //搜索表单
      searchForm: {
        czlx: "",
        zwlx: "",
        reserve2: "01"
      },
      that: this,
      title: "",
      tableData: [],
      //表高度变量
      tableheight: this.CONSTANT.tableheight10,
      //多选值
      multipleSelection: [],
      //显示加载中样
      loading: false,
      //当前页
      currentPage: 1,
      //分页大小
      pageSize: 10,
      //总记录数
      total: 0,
      form: {
        zwlx: "",
        zwlxmc: "",
        czlx: "",
        min: "",
        max: "",
        minNum: "",
        maxNum: "",
        reserve2: ""
      },
      rules: {
        reserve2: [
          { required: true, message: "请选择类型", trigger: "change" }
        ],
        zwlx: [
          { required: true, message: "请选择展位类型", trigger: "change" }
        ],
        czlx: [
          { required: true, message: "请选择展品类型", trigger: "change" }
        ],
        min: [
          { required: true, message: "请输入最小面积", trigger: "blur" },
          {
            pattern: /^([0-9]\d{0,9}|0)?$/,
            message: "最小面积应为最多10位整数",
            trigger: "blur"
          },
        ],
        max: [
          { required: true, message: "请输入最大面积", trigger: "blur" },
          {
            pattern: /^([0-9]\d{0,9}|0)?$/,
            message: "最大面积应为最多10位整数",
            trigger: "blur"
          }
        ],
        minNum: [
          { required: true, message: "请输入最小个数", trigger: "blur" },
          {
            pattern: /^([0-9]\d{0,9}|0)?$/,
            message: "最小个数应为最多10位整数",
            trigger: "blur"
          }
        ],
        maxNum: [
          { required: true, message: "请输入最大个数", trigger: "blur" },
          {
            pattern: /^([0-9]\d{0,9}|0)?$/,
            message: "最大个数应为最多10位整数",
            trigger: "blur"
          }
        ],
      },
      open: false,
      zwlxOption: [],
      czlxOption: [],
    };
  },
  created () {
    if(this.$store.state.listPagePars.has(this.$route.path)){
			this.searchForm = this.$store.state.listPagePars.get(this.$route.path);
			this.currentPage = this.searchForm.pageNum;
			this.pageSize = this.searchForm.pageSize;
		}
    this.searchClick('page');
    this.selectZwlxOption()
    this.selectCzlxOption()
  },
  filters: {
    setZWLX (val, that) {
      if (!val || that.zwlxOption.length <= 0) return "";
      return that.zwlxOption.filter(item => {return item.codeValue == val}).length > 0 ? that.zwlxOption.filter(item => {return item.codeValue == val})[0].codeName : "";
    },
    setCZLX (val, that) {
      if (!val || that.czlxOption.length <= 0) return "";
      return that.czlxOption.filter(item => {return item.codeValue == val}).length > 0 ? that.czlxOption.filter(item => {return item.codeValue == val})[0].codeName : "";
    },
  },
  methods: {
    // 选择展位类型
    checkZwlx (e) {
      this.form.min = "";
      this.form.max = "";
      this.form.minNum = "";
      this.form.maxNum = "";
      this.form.zwlxmc = this.zwlxOption.filter(item => item.codeValue == e).length > 0 ?this.zwlxOption.filter(item => item.codeValue == e)[0].codeName : ""
    },
    // 展位类型
    selectZwlxOption () {
      this.$axios.get('/codelist/getCodetype/ZWLX').then((res) => {
        this.zwlxOption = res.data.result
      })
    },
    // 展品类型
    selectCzlxOption () {
      let vm = this;
      this.$axios.get('/codelist/getCodetype/CZLX').then((res) => {

        //this.czlxOption = res.data.result
        vm.czlxOption=[];
          for(let i in res.data.result){
            if(res.data.result[i].codeValue !='99'){
              vm.czlxOption.push(res.data.result[i]);
            }
          }
      })
    },
    //表格查询事件
    searchClick (type) {
      let vm = this;
      this.tableData = [];
      if (type != 'page') {
        this.currentPage = 1;
      }
      vm.loading = true;//表格重新加载
      var params = {
        zwlx: vm.searchForm.zwlx,
        czlx: vm.searchForm.czlx,
        reserve2: vm.searchForm.reserve2,
        pageSize: vm.pageSize,
        pageNum: vm.currentPage
      }
      vm.$axios.post('/cfpadwmjfw/page', params).then(function (res) {
        var tableTemp = new Array((vm.currentPage-1)*vm.pageSize);
        vm.tableData = tableTemp.concat(res.data.result.list);
        this.total = res.data.result.total;
        this.loading = false;
         this.$store.dispatch('saveListPagePars', {path: this.$route.path, pars: params});
      }.bind(this), function (error) {
        console.log(error)
      })
    },

    //清空查询条件
    clearClick () {
      this.searchForm.zwlx = '';
      this.searchForm.czlx = '';
      this.searchForm.reserve2 = '01'
      this.searchClick('reset');
    },

    //表格勾选事件
    selectionChange (val) {
      this.multipleSelection = val;
    },

    //新增事件
    addClick: function() {
      this.form = {
        zwlx: "",
        zwlxmc: "",
        czlx: "",
        min: "",
        max: "",
        minNum: "",
        maxNum: "",
        reserve2: ""
      },
      this.title = "新增档位面积"
      this.open = true
    },

    //关闭Dialog
    closeDialog () {
      this.$refs["form"].resetFields();
      this.open = false;
    },

    //表格修改事件
    editClick: function(val, index) {
      this.$axios.get("cfpadwmjfw/" + val.uuid).then(res => {
        if (res.data.code == "00000000") {
          this.form = res.data.result
          console.log(this.form);
          this.title = "编辑档位面积"
          this.open = true
        }
      })
    },
     //删除所选，批量删除
    deleteClick: function() {
      this.$confirm('确定删除已选中档位?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let vm = this;
        for (var i in this.multipleSelection) {
          vm.multipleSelection[i].xgrid = this.currentUser.userid;
          vm.multipleSelection[i].xgrmc = this.currentUser.username;
          vm.multipleSelection[i].deleteFlag = 'Y';
        }
        vm.$axios.post('/cfpadwmjfw/doDeleteDwmjfwList', vm.multipleSelection).then(function (res) {
          vm.$message({
            message: "成功删除" + res.data.result + "条信息",
            showClose: true,
            onClose: this.searchClick('delete')
          });
        }.bind(this), function (error) {
          console.log(error)
        })
      }).catch(() => {
        vm.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },


    // 保存
    save () {
      this.$refs["form"].validate((valid) => {
        if(valid) {
          if (!this.form.uuid) {
            this.form.cjrid = this.currentUser.userid;
            this.form.userid = this.currentUser.userid;
            // this.form.cjrmc = this.currentUser.username;
            this.$axios.post("/cfpadwmjfw/insertByVODwmjfw", this.form).then(res => {
              if (res.data.code == "00000000") {
                this.$message.success("新增成功")
                this.open = false
                this.searchClick("add")
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(err => {
              this.$message.error("新增失败")
            })
          } else {
            this.form.xgrid = this.currentUser.userid;
            this.form.xgrmc = this.currentUser.username;
            this.$axios.put("/cfpadwmjfw/updateByVODwmjfw", this.form).then(res => {
              if (res.data.code == "00000000") {
                this.$message.success("编辑成功")
                this.open = false
                this.searchClick("page")
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(err => {
              this.$message.error("编辑失败")
            })
          }
        }
      })
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/GearList/index.vue